import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlDotacao = '/service/contabilidade/dotacao/'

class DotacaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getExercicios() {
        return this.conex.get(urlDotacao + 'exercicios/')
    }
}

export default DotacaoService
